module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/123-british-columbia-9c4215bda7716d1c034bd27c96f01672.svg";